import mapDocument from "../utils/mapDocument";

export default function runTransaction(firebase, refsOrDocuments = [], callback, transaction, debug = false) {
	const runCallback = async (transaction) => {
		const documents = await transaction.getAllDocuments(refsOrDocuments);

		return callback(transaction, documents);
	};

	if (transaction) {
		return runCallback(transaction);
	}

	return firebase.firestore().runTransaction(async (firestoreTransaction) => {
		const cache = {};
		const mutations = [];
		const transaction = {
			set: (...args) => mutations.push(["set", ...args]),
			update: (...args) => mutations.push(["update", ...args]),
			delete: (...args) => mutations.push(["delete", ...args]),
			get: (ref) => {
				return firestoreTransaction.get(ref);
			},
			getDocument: (refOrDocument) => {
				const ref = refOrDocument?.ref || refOrDocument;

				if (cache[ref.path]) {
					return cache[ref.path];
				}

				return (cache[ref.path] = firestoreTransaction.get(ref).then(mapDocument));
			},
			getAllDocuments: (refsOrDocuments) => {
				return Promise.all(
					refsOrDocuments.map((refOrDocument) => {
						if (Array.isArray(refOrDocument)) {
							return transaction.getAllDocuments(refOrDocument);
						}

						if (refOrDocument) {
							return transaction.getDocument(refOrDocument);
						}
					}),
				);
			},
		};

		const result = await runCallback(transaction);

		for (const [method, ref, ...args] of mutations) {
			if (debug) {
				console.log("[runTransaction]", method, ref.path, JSON.stringify(args, null, 2));
			} else {
				firestoreTransaction[method](ref, ...args);
			}
		}

		return result;
	});
}
